import { LOADING_TAB_HTML } from './loadingTabHtml';

export const openLoadingTab = () => {
  const tab = window.open('', '_blank');

  if (tab) {
    tab.document.open();
    tab.document.write(LOADING_TAB_HTML);
    tab.document.close();
    tab.opener = null;
  }

  return tab;
};
